<template>
  <div>
    <gg-modal :is-active="autorenewModalOpen" @close="closeModalAutorenew">
      <template v-slot:toolbar>
        Enabling auto renew error
      </template>
      <template v-slot:body>
        Your service is not eligible to enable auto renew. Please contact Billing for assistance.
      </template>
      <template v-slot:actions>
        <gg-btn @click="closeModalAutorenew">Close</gg-btn>
      </template>
    </gg-modal>
    <gg-modal :is-active="autorenewModalConfirmOpen" @close="closeModalAutorenewConfirm">
      <template v-slot:toolbar>
        Enabling auto renew
      </template>
      <template v-slot:body>
        <p>This service will be set to auto-renew. Our system will automatically renew your account to ensure your account stays active.</p>

        <p>Are you sure you want to enable auto renewal?</p>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeModalAutorenewConfirm">No</gg-btn>
        <gg-btn primary :loading="autorenewLoading" @click="acceptModalAutorenewConfirm">Yes</gg-btn>
      </template>
    </gg-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cancellationTypes } from '@/consts/cancellations'

export default {
  name: 'AutoRenewModal',

  data () {
    return {
      cancellationTypes,
      autorenewModalOpen: false,
      autorenewModalConfirmOpen: false,
      autorenewLoading: false,
    }
  },

  computed: {
    ...mapGetters(['hosting']),
  },

  methods: {
    ...mapActions({
      enableAutorenew: 'enableAutorenew',
    }),
    closeModalAutorenew () {
      this.autorenewModalOpen = false
    },
    openModalAutorenew () {
      this.autorenewModalOpen = true
    },
    canAutorenewProceed () {
      if (!this.hosting.can_enable_autorenew) {
        this.openModalAutorenew()
        return
      }
      this.openModalAutorenewConfirm()
    },
    async callEnableAutorenew () {
      await this.enableAutorenew({ service_id: this.hosting.id, service_type: cancellationTypes.HOSTING, cancellation_id: this.hosting.cancellation_id })
    },
    closeModalAutorenewConfirm () {
      this.autorenewModalConfirmOpen = false
    },
    openModalAutorenewConfirm () {
      this.autorenewModalConfirmOpen = true
    },
    async acceptModalAutorenewConfirm () {
      this.autorenewLoading = true
      try {
        await this.callEnableAutorenew()
      } finally {
        this.autorenewLoading = false
      }
      this.closeModalAutorenewConfirm()
    },
  },
}
</script>

<style scoped>
</style>
